var map = {
	"./fedesi-szelesseg-rundo-a-en.png": 7133,
	"./fedesi-szelesseg-rundo-a.png": 9197,
	"./fedesi-szelesseg-rundo-b-en.png": 6180,
	"./fedesi-szelesseg-rundo-b.png": 1782,
	"./fedesi-szelesseg-rundo-c-en.png": 3047,
	"./fedesi-szelesseg-rundo-c.png": 527,
	"./fedesi-szelesseg-rundo-d-en.png": 7614,
	"./fedesi-szelesseg-rundo-d.png": 4656,
	"./fedesi-szelesseg-synus-en.png": 8153,
	"./fedesi-szelesseg-synus.png": 9289,
	"./fedesi-szelesseg-zenit-max-a-en.png": 8814,
	"./fedesi-szelesseg-zenit-max-a.png": 5120,
	"./fedesi-szelesseg-zenit-max-b-en.png": 2931,
	"./fedesi-szelesseg-zenit-max-b.png": 4971,
	"./fedesi-szelesseg–danubia-coppo-en.png": 8765,
	"./fedesi-szelesseg–danubia-coppo.png": 3373
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2257;